import { Link } from "react-router-dom";
import { getWhatsAppHref, WHATSAPP_MESSAGES } from "../config/forms.js";
import { HERO_ROLES } from "../data/heroRoles.js";
import { PH } from "../components/PH.jsx";
import { RoleRotor } from "../components/RoleRotor.jsx";
import { ScribbleUnderline } from "../components/ScribbleUnderline.jsx";

export function Hero() {
  const whatsappHref = getWhatsAppHref(WHATSAPP_MESSAGES.join);

  return (
    <header id="top" className="hero shell">
      <div className="hero-meta-row reveal">
        <div className="mono">A new operating system / for creative + technology collaboration</div>
        <div className="mono center">Est. 2026 — Bombay · Bengaluru · Everywhere</div>
        <div className="mono right">Currently inviting · v0.1</div>
      </div>

      <h1 className="hero-headline reveal">
        The future won&apos;t
        <br />
        belong to{" "}
        <span className="scribble">
          companies
          <ScribbleUnderline />
        </span>
        .
        <br />
        It will belong to <em>tribes.</em>
      </h1>

      <div className="hero-grid">
        <div className="reveal">
          <p className="lead lead-flush">
            Alt Tribe is building a new kind of ecosystem for creative thinkers,
            strategists, technologists, builders, and unconventional minds.
          </p>
          <p className="body body-muted">
            A tribe powered by collaboration, purpose, and generative AI.
          </p>

          <div className="hero-actions">
            {whatsappHref ? (
              <a
                href={whatsappHref}
                className="btn btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Chat on WhatsApp <span className="arr" aria-hidden="true" />
              </a>
            ) : (
              <Link to="/apply" className="btn btn-primary">
                Join the tribe <span className="arr" aria-hidden="true" />
              </Link>
            )}
            <Link to="/apply" className="btn btn-ghost">
              Submit application
            </Link>
            <a href="#ecosystem" className="btn btn-ghost">
              Explore the ecosystem
            </a>
          </div>

          <div className="hero-role-row">
            <span className="mono">Now forming the tribe:</span>
            <RoleRotor words={HERO_ROLES} />
          </div>
        </div>

        <div className="hero-portraits reveal" aria-label="Community imagery">
          <PH label="01 / Portrait — builder at work" />
          <PH label="02 / B&W close-up" dark />
          <PH label="03 / Hands + notebook" />
          <PH label="04 / Wide group, studio" dark />
        </div>
      </div>
    </header>
  );
}
